import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from '@/components/molecules';
import { WarehouseDetail, WarehouseForm } from '@/components/organisms/Warehouse';
import { useWarehouseDetail } from '@/hooks/useErpApi';

export default function WarehouseDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { data: warehouse, refetch } = useWarehouseDetail(id || '');

  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleFormSuccess = () => {
    setIsEditModalOpen(false);
    refetch();
  };

  if (!id) {
    return (
      <div className="p-8">
        <div className="bg-error-50 border border-error-200 rounded-lg p-6">
          <p className="text-error-700">Invalid warehouse ID</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <WarehouseDetail warehouseId={id} onEditClick={handleEditClick} />

      <Modal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        title="Edit Warehouse"
        size="lg"
      >
        {warehouse && (
          <WarehouseForm
            initialData={warehouse}
            onSuccess={handleFormSuccess}
            onCancel={() => setIsEditModalOpen(false)}
          />
        )}
      </Modal>
    </div>
  );
}
